import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData, IResponseData,
    PromoPanelGameConfiguration,
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {WalkOfShame} from "./WalkOfShame";
import {BelowStakeWinRestriction} from "./server/BelowStakeWinRestriction";
import {WalkOfShameGameMode} from "./server/WalkOfShameGameMode";
import {WalkOfShameSound} from "./sound/WalkOfShameSound";
import {WalkOfShameGameAssets} from "./WalkOfShameGameAssets";
import {IWalkOfShameGameData} from "./server/data/IWalkOfShameData";

export class WalkOfShamePromoPanelConfig implements PromoPanelGameConfiguration {

    constructor() {
    }

    public getActionSpinOptions(): ActionSpinOptions {
        return {
            gameName: "WalkOfShame",
            hasActionSpin: true,

            graphics: {backgroundTextureName: WalkOfShameGameAssets.MAIN_GAME_BACKGROUND},
            getParsedData: (response: IWalkOfShameGameData, bet: number, prevResponse: IWalkOfShameGameData): ASWinData => {
                const win = this.getWin(response, bet, prevResponse);
                const parsedData: ASWinData = {
                    totalWin: response.accumulatedRoundWin,
                    totalSpinWinnings: win,
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: this.isFreeSpinTriggered(response),
                    isBigWin: this.isBigWin(response, win),
                    winType: WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response),
                    isRoundComplete: this.isRoundComplete(response),
                    isBonusEnd: this.isBonusEnd(response),
                    isWinCapHit: response.brokeTheBank
                }
                // parsedData.isBigWin = this.isBigWin(response.totalSpinWinnings, response.playedBetValue, response.mode);
                return parsedData;
            }
        };
    }

    public onActionSpinPlaySound(trigger: ActionSpinSound): void {
        if (trigger == ActionSpinSound.WIN) {
            WalkOfShame.sound.playEffect(WalkOfShameSound.AS_WIN);
        } else if (trigger == ActionSpinSound.BIG_WIN) {
            WalkOfShame.sound.playEffect(WalkOfShameSound.AS_WIN_BIG);
        }
    }

    private isBigWin(response: IWalkOfShameGameData, win:number): boolean {
        const playedBetValue = response.playedBetValue;
        let winRatio: number = Helper.ceilToDecimals((win / playedBetValue), 2);

        if (response.wasFeatureBuy) {
            const betPrice = BelowStakeWinRestriction.getBuyFeaturePrice()
            winRatio = Helper.ceilToDecimals((win / betPrice), 2);
            return winRatio >= 1;
        }

        return winRatio >= 15;
    }

    private respinRoundWin = 0;
    private getWin(response: IWalkOfShameGameData, bet: number, prevData: IWalkOfShameGameData): number {
        let win =  ((response.mode === WalkOfShameGameMode.RESPIN && response.nextMode === WalkOfShameGameMode.NORMAL) || response.mode === WalkOfShameGameMode.NORMAL) ? response.accumulatedRoundWin : response.totalSpinWinnings;

        if (response.mode == WalkOfShameGameMode.SUPER_FREESPIN_RESPIN) {
            this.respinRoundWin += response.totalSpinWinnings;
        }

        if (response.mode == WalkOfShameGameMode.SUPER_FREESPIN_RESPIN && response.nextMode == WalkOfShameGameMode.SUPER_FREESPIN ) {
            win = this.respinRoundWin;
            this.respinRoundWin = 0;
        }
        return win;
    }

    private getFeatureName(response: IWalkOfShameGameData): string {
        if (response.nextMode == WalkOfShameGameMode.FREESPIN || response.mode == WalkOfShameGameMode.FREESPIN) {
            return "ONE MORE!!!";
        }

        if (response.nextMode == WalkOfShameGameMode.SUPER_FREESPIN || response.mode == WalkOfShameGameMode.SUPER_FREESPIN || response.mode === WalkOfShameGameMode.SUPER_FREESPIN_RESPIN || response.nextMode === WalkOfShameGameMode.SUPER_FREESPIN_RESPIN) {
            return "ALL NIGHTER";
        }

/*        if (response.nextMode == WalkOfShameGameMode.RESPIN || response.mode == WalkOfShameGameMode.RESPIN) {
            return "WALK OF SHAME";
        }*/

        return "";
    }
    isLegalStopOnBonusMode(data: IResponseData): boolean {
        return data.nextMode != WalkOfShameGameMode.RESPIN;
    }

    private isFreeSpinTriggered(response: IWalkOfShameGameData): boolean {
        const isFs = (response.mode == WalkOfShameGameMode.NORMAL || response.mode == WalkOfShameGameMode.RESPIN) && response.nextMode == WalkOfShameGameMode.FREESPIN;
        const isSfs = (response.mode == WalkOfShameGameMode.NORMAL || response.mode == WalkOfShameGameMode.RESPIN) && response.nextMode == WalkOfShameGameMode.SUPER_FREESPIN;
        //const isRespin = response.mode == WalkOfShameGameMode.NORMAL &&  response.nextMode == WalkOfShameGameMode.RESPIN;
        return isFs || isSfs;
    }

    private isRoundComplete(response: IWalkOfShameGameData): boolean {
        return ([WalkOfShameGameMode.NORMAL, WalkOfShameGameMode.FREESPIN, WalkOfShameGameMode.SUPER_FREESPIN].indexOf(response.nextMode) > -1);
    }

    private isBonusEnd(response: IWalkOfShameGameData): boolean {
        return (response.mode === WalkOfShameGameMode.FREESPIN || response.mode === WalkOfShameGameMode.SUPER_FREESPIN) && response.nextMode === WalkOfShameGameMode.NORMAL;
    }

}